import React, { useState } from "react";
import Swal from "sweetalert2";
import styled from "styled-components";
import withReactContent from "sweetalert2-react-content";
import { createGlobalStyle } from "styled-components";
import SocialLinks from "../../Elements/SocialLinks";


// Styled Components
const ContactSection = styled.section`
  padding: 60px 20px;
  background-color: #f9f9f9;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const SectionTitle = styled.div`
  text-align: center;
  margin-bottom: 50px;
  h2 {
    font-size: 32px;
    font-weight: 700;
    color: #333;
  }

  @media (max-width: 768px) {
    h2 {
      font-size: 28px;
    }
  }
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 30px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
  }
`;

const ContactAbout = styled.div`
  flex: 2;
  h3 {
    font-size: 24px;
    margin-bottom: 10px;
    font-weight: 700;
    color: #222222;
  }
  p {
    font-size: 14px;
    line-height: 24px;
    font-family: "Raleway", sans-serif;
    color: #888;
  }

  @media (max-width: 768px) {
    h3 {
      font-size: 20px;
    }
    p {
      font-size: 13px;
    }
  }
`;

const MapContainer = styled.div`
  position: relative;
  width: 100%;
  height: 300px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    height: 200px;
  }
`;

const InfoContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 10px;
  }
`;

const InfoItem = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;

  i {
    font-size: 28px;
    color: #db3434;
  }

  p {
    margin: 0;
    font-size: 14px;
    color: #444;
  }

  p a {
    color: gray;
    text-decoration: none;
    transition: color 0.3s;
  }

  p a:hover {
    color: #db3434;
  }

  @media (max-width: 768px) {
    i {
      font-size: 24px;
    }
    p {
      font-size: 12px;
    }
  }
`;

const Form = styled.form`
  flex: 2;

  .form-group {
    margin-bottom: 20px;
  }

  input,
  textarea {
    border-radius: 10px;
    box-shadow: none;
    font-size: 14px;
    padding: 10px 15px;
    width: 100%;
    border: 1px solid #ccc;
    background: #fff;
  }

  input:focus,
  textarea:focus {
    border-color: rgb(67, 153, 239);
    outline: none;
  }

  button[type="submit"] {
    background: linear-gradient(
      90deg,
      rgb(87, 143, 255) 0%,
      rgb(67, 153, 239) 100%
    );
    border: none;
    padding: 12px 30px;
    color: #fff;
    border-radius: 50px;
    font-size: 16px;
    cursor: pointer;
    transition: background 0.3s;
  }

  button[type="submit"]:hover {
    background: rgb(67, 153, 239) 100%;
  }

  @media (max-width: 768px) {
    .form-group {
      margin-bottom: 15px;
    }

    input,
    textarea {
      font-size: 12px;
    }

    button[type="submit"] {
      padding: 10px 20px;
      font-size: 14px;
    }
  }
`;

const Loading = styled.div`
  text-align: center;
  padding: 15px;
`;

const SentMessage = styled.div`
  color: #fff;
  background: #18d26e;
  text-align: center;
  padding: 8px;
  font-weight: 600;
  border-radius: 10px;
`;

const ErrorMessage = styled.div`
  color: #fff;
  background: #ed3c0d;
  text-align: center;
  padding: 8px;
  font-weight: 600;
  border-radius: 10px;
`;
const SweetAlertStyles = createGlobalStyle`
  .swal2-popup {
    border-radius: 12px;
    background: linear-gradient(135deg, #ffffff, #f0f4ff);
    box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.2);
  }

  .swal2-title {
    font-size: 22px;
    font-weight: 700;
    color: #333;
    font-family: "Raleway", sans-serif;
  }

  .swal2-confirm {
    background: linear-gradient(90deg, rgb(87, 143, 255) 0%, rgb(67, 153, 239) 100%);
    padding: 12px 20px;
    border-radius: 30px;
    font-size: 16px;
    font-weight: bold;
  }

  .swal2-confirm:hover {
    background: rgb(67, 153, 239);
  }

  .swal2-icon {
    border-radius: 50%;
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
  }
`;

// Other styled components remain unchanged...

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSent, setIsSent] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const MySwal = withReactContent(Swal);
  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setError(null);

    try {
      const response = await fetch(
        "https://pristineacademicconsultancy.com/Admin/contact.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const result = await response.json();
      if (result.success) {
        setIsSent(true);
        setFormData({ name: "", email: "", subject: "", message: "" });

        MySwal.fire({
          title: "Success!",
          text: "Your message has been sent successfully!",
          icon: "success",
          confirmButtonColor: "#4399ef",
          customClass: {
            popup: "swal2-popup",
            title: "swal2-title",
            confirmButton: "swal2-confirm"},
        });
      } else {
        MySwal.fire({
          title: "Failed",
          text:
            result.message ||
            "Failed to send your message. Please try again later.",
          icon: "error",
          confirmButtonColor: "#ed3c0d",
          customClass: {
            popup: "swal2-popup",
            title: "swal2-title",
            confirmButton: "swal2-confirm"},
            });
      }
    } catch (err) {
      MySwal.fire({
        title: "Error",
        text: "Error connecting to the server. Please try again later.",
        icon: "error",
        confirmButtonColor: "#ed3c0d",
        customClass: {
          popup: "swal2-popup",
          title: "swal2-title",
          confirmButton: "swal2-confirm"},
        
      });
    }

    setIsSubmitting(false);
  };

  return (
    <>
    <SweetAlertStyles />
    <ContactSection id="contact">
      <Container>
        <SectionTitle>
          <h2>Contact Us</h2>
        </SectionTitle>

        <Row>
          <ContactAbout>
            <h3>Pristine Academic Consultancy</h3>
            <p>
              Contact us for expert advice and assistance with your academic and
              educational needs. Reach out via phone, email, or visit us at our
              offices in Nairobi. We are here to help you achieve success.
            </p>
            <MapContainer>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1994.6718212430918!2d36.82194691581653!3d-1.286389!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f10d5f8eb1a65%3A0x607b2d1fd81569b1!2sNairobi!5e0!3m2!1sen!2ske!4v1721900088474!5m2!1sen!2ske"
                width="100%"
                height="100%"
                style={{ border: 4 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </MapContainer>
          </ContactAbout>

          <InfoContainer>
            <InfoItem>
              <i className="ri-map-pin-line"></i>
              <p>Nairobi, Kenya</p>
            </InfoItem>
            <InfoItem>
              <i className="ri-mail-send-line"></i>
              <p>
                <a href="mailto:pristineeduconsult@gmail.com">
                  pristineacademicconsultancy@gmail.com
                </a>
              </p>
            </InfoItem>
            <InfoItem>
            <SocialLinks/>
            </InfoItem>
          </InfoContainer>
         

          <Form onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="subject"
                placeholder="Subject"
                value={formData.subject}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <textarea
                name="message"
                rows="5"
                placeholder="Message"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>

            {isSubmitting && <Loading>Sending your message...</Loading>}
            {error && <ErrorMessage>{error}</ErrorMessage>}
            {isSent && (
              <SentMessage></SentMessage>
            )}

            <button type="submit" disabled={isSubmitting}>
              {isSubmitting ? "Sending..." : "Send Message"}
            </button>
          </Form>
        </Row>
      </Container>
    </ContactSection>
    </>
  );
};

export default Contact;
